import React, { useEffect, useState } from "react";
import {
  MDBCardBody,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
  MDBCard,
  MDBSelect,
  MDBCol,
  MDBSpinner,
  MDBRow,
  MDBInput,
  MDBBtn,
  MDBIcon,
} from "mdbreact";
import Select from "react-select";
import http from "../../services/http";
import DateInput from "../../components/DateInput";

const ageOptions = [
  {
    value: "r2",
    label: "35+",
  },
  {
    value: "r1",
    label: "34-",
  },
];

const osOptions = [
  { label: "Android", value: "Android" },
  { label: "iOS", value: "iOS" },
  { label: "Linux", value: "Linux" },
  { label: "Windows", value: "Windows" },
  { label: "Other", value: "Other" },
];

const Filters = ({
  groupingOptions = [],
  loadingGrouping = true,
  grouping,
  setGrouping,
  setIsSettingsVisible,
  filtersConfig,
  filterForm,
  setFilterForm,
  dateForm,
  setDateForm,
  handleSubmit,
}) => {
  const [partnerOptions, setPartnerOptions] = useState([]);

  const fetchPartnerOptions = async () => {
    const { data } = await http.get("/reports/main_partners");
    const formatted = data.map((item) => ({
      value: item.value,
      label: item.text,
    }));
    setPartnerOptions(formatted);
  };
  useEffect(() => {
    fetchPartnerOptions();
  }, []);

  const renderInput = (label, id) => {
    if (filtersConfig.includes(id)) return null;
    return (
      <MDBCol lg="3" md="6">
        <MDBInput
          required
          label={label}
          type="text"
          group
          value={filterForm[id]}
          onChange={(e) =>
            setFilterForm({
              ...filterForm,
              [id]: e.target.value,
            })
          }
        />
      </MDBCol>
    );
  };

  const renderDropdown = (label, id, options) => {
    if (filtersConfig.includes(id)) return null;
    return (
      <MDBCol lg="3" md="6">
        <Select
          isSearchable={false}
          styles={{ control: (s) => ({ ...s, marginTop: 25 }) }}
          placeholder={label}
          options={options}
          isClearable
          onChange={(val) =>
            setFilterForm({
              ...filterForm,
              [id]: val?.value || "",
            })
          }
        />
      </MDBCol>
    );
  };
  return (
    <MDBCard className="p-2 mb-5">
      <MDBCardBody>
        <MDBRow>
          <MDBCol>
            <Select
              isSearchable={false}
              placeholder={"First grouping"}
              options={groupingOptions}
              isLoading={loadingGrouping}
              value={groupingOptions.find(
                (option) => option.value === grouping.first
              )}
              styles={{ menu: (s) => ({ ...s, zIndex: 2, }) }}
              onChange={(selectedOption) =>
                setGrouping({ ...grouping, first: selectedOption.value })
              }
            />
          </MDBCol>
          <MDBCol>
            <Select
              isSearchable={false}
              placeholder={"Second grouping"}
              isClearable
              options={groupingOptions}
              isLoading={loadingGrouping}
              value={groupingOptions.find(
                (option) => option.value === grouping.second
              )}
              styles={{ menu: (s) => ({ ...s, zIndex: 2, }) }}
              onChange={(selectedOption) =>
                setGrouping({ ...grouping, second: selectedOption?.value })
              }
            />
          </MDBCol>
          <MDBCol>
            <Select
              isSearchable={false}
              placeholder={"Third grouping"}
              isClearable

              options={groupingOptions}
              isLoading={loadingGrouping}
              value={groupingOptions.find(
                (option) => option.value === grouping.third
              )}
              styles={{ menu: (s) => ({ ...s, zIndex: 2, }) }}
              onChange={(selectedOption) =>
                setGrouping({ ...grouping, third: selectedOption?.value })
              }
            />
          </MDBCol>
        </MDBRow>
        <MDBRow className="mt-2">
          {!filtersConfig.includes("date") ? (
            <DateInput
              value={dateForm}
              onChange={(value) => setDateForm(value)}
            />
          ) : null}
          {renderInput("Linkid", "LinkId")}
          {renderInput("WebId", "WebId")}
          {renderInput("SubId", "SubId")}
        </MDBRow>
        <MDBRow className="mt-2">
          {renderInput("Utm_Source", "UtmSource")}
          {renderDropdown("Age", "Age", ageOptions)}
          {renderInput("Utm_Campaign", "UtmCampaign")}
          {renderDropdown("OS", "OS", osOptions)}
        </MDBRow>
        <MDBRow className="mt-2">
          {renderDropdown("Partner", "Partner", partnerOptions)}
          {renderInput("Landing", "Path")}
        </MDBRow>
        <div style={{ display: "flex", flex: 1, justifyContent: "flex-end", gap: 10, alignItems: "center" }}>
          <MDBBtn
            disabled={!dateForm.to || !dateForm.from}
            onClick={handleSubmit}
          >
            Apply
          </MDBBtn>
          <div
            style={{ cursor: "pointer" }}
            onClick={() => setIsSettingsVisible(true)}
          >
            <MDBIcon icon="landmark" color="red" size="lg" />
          </div>
        </div>
      </MDBCardBody>
    </MDBCard>
  );
};

export default Filters;
